/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingMakersModule_contemporaryLandingRow$ref: FragmentReference;
export type ContemporaryLandingMakersModule_contemporaryLandingRow = {|
  +items: ?$ReadOnlyArray<?{|
    +text?: ?string,
    +type?: ?string,
    +items?: ?$ReadOnlyArray<?{|
      +bgImagePath?: ?string,
      +location?: ?string,
      +name?: ?string,
      +type?: ?string,
      +url?: ?string,
      +userImagePath?: ?string,
      +imagePath?: ?string,
      +text?: ?string,
    |}>,
  |}>,
  +$refType: ContemporaryLandingMakersModule_contemporaryLandingRow$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContemporaryLandingMakersModule_contemporaryLandingRow",
  "type": "ContemporaryLandingRow",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingRow",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "ContemporaryLandingMakerRowItem",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imagePath",
                      "args": null,
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v2/*: any*/)
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "ContemporaryLandingHeroMakerRowItem",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "bgImagePath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "name",
                      "args": null,
                      "storageKey": null
                    },
                    (v1/*: any*/),
                    (v2/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "userImagePath",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            },
            (v1/*: any*/)
          ]
        },
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingHeader",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '9dce0cc3a3156555111dc290a0b4bbb3';
module.exports = node;
